import { Reveal, Eyebrow } from "./Reveal";
import { AUDIENCE_PILLARS, MARKETS } from "../data/content";

export const Audience = () => (
    <section id="audience" data-testid="audience-section" className="mx-auto max-w-[1500px] px-5 sm:px-8 py-24 sm:py-36">
        <Reveal className="mb-16 max-w-4xl">
            <Eyebrow>The Audience</Eyebrow>
            <h2 className="deck-heading font-display text-5xl sm:text-6xl tracking-[0.12em]">
                THE AUDIENCE IS <span>ALREADY WAITING</span>
            </h2>
            <p className="mt-6 text-base sm:text-lg leading-relaxed text-zinc-400">
                Core audience: <span className="text-white">women 18–29</span> — sitting at the intersection of three
                genres already proven at scale.
            </p>
        </Reveal>

        <div className="grid gap-4 lg:grid-cols-3">
            {AUDIENCE_PILLARS.map((p, i) => (
                <Reveal key={p.id} delay={i * 0.1}>
                    <article
                        data-testid={`audience-pillar-${p.id}`}
                        className="group flex h-full flex-col border border-white/10 bg-[#0b1220] p-8 transition-colors duration-500 hover:border-[#d6c68e]/40"
                    >
                        <p className="font-mono text-[10px] tracking-[0.3em] text-zinc-500">{p.genre.toUpperCase()}</p>
                        <p className="mt-6 font-display text-6xl sm:text-7xl text-[#d6c68e]">{p.stat}</p>
                        <p className="mt-2 text-[13px] font-medium leading-snug text-zinc-300">{p.statLabel}</p>
                        <p className="mt-5 text-sm leading-relaxed text-zinc-500">{p.text}</p>
                    </article>
                </Reveal>
            ))}
        </div>

        <Reveal delay={0.1} className="mt-20">
            <p className="mb-8 font-mono text-[10px] tracking-[0.35em] text-zinc-500">LAUNCH MARKETS</p>
            <div className="grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
                {MARKETS.map((m) => (
                    <div
                        key={m.id}
                        data-testid={`market-card-${m.id}`}
                        className="group bg-[#070c18]/70 p-7 transition-colors duration-500 hover:bg-[#101a2e]"
                    >
                        <h3 className="font-display text-2xl tracking-[0.06em] text-white group-hover:text-[#d6c68e] transition-colors duration-300">
                            {m.name.toUpperCase()}
                        </h3>
                        <p className="mt-3 text-[13px] leading-relaxed text-zinc-500">{m.text}</p>
                    </div>
                ))}
            </div>
        </Reveal>
    </section>
);
